import { memo, useMemo, useState } from 'react'
import { Box, Typography, Button } from '@mui/material'
import CustomDialog from '../dialog'
import MonthlyReportTab from '../../pages/subscription/components/MonthlyReportTab'

const CreditUsageEvent = ({ data }) => {
  const [openDialog, setOpenDialog] = useState(false)
  // Variable
  const formattedMonths = useMemo(() => {
    if (!data?.month || !Array.isArray(data.month) || data.month.length === 0)
      return ''

    const formatted = data.month.map((m) => {
      const str = m.toLowerCase()
      return str.charAt(0).toUpperCase() + str.slice(1)
    })

    if (formatted.length === 1) return formatted[0]
    if (formatted.length === 2) return `${formatted[0]} and ${formatted[1]}`
    return `${formatted.slice(0, -1).join(', ')} and ${
      formatted[formatted.length - 1]
    }`
  }, [data?.month])

  return (
    <>
      <Box className="chatbot-message__markdown">
        <Typography variant="body2" sx={{ color: 'text.primary', mb: 1.5 }}>
          Total credit usage{' '}
          {data?.contestName ? (
            <>
              for <strong>{data?.contestName}</strong>{' '}
            </>
          ) : (
            ''
          )}
          is <strong>{data?.credits || 0}</strong> for Month {formattedMonths}{' '}
          {data?.year}
        </Typography>

        {!data?.contestId && (
          <>
            <Typography
              variant="caption"
              sx={{
                color: 'text.secondary',
                display: 'block',
                mb: 1,
                lineHeight: 1.5
              }}
            >
              To see details usage click the below button
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              fullWidth
              onClick={() => setOpenDialog(true)}
              sx={{
                textTransform: 'none',
                py: 0.5,
                borderRadius: 1,
                fontWeight: 600,
                fontSize: '12px'
              }}
            >
              Credit Breakup
            </Button>
          </>
        )}
      </Box>

      {openDialog && (
        <CustomDialog
          open={openDialog}
          handleClose={() => setOpenDialog(false)}
          title="Usage Report"
          dialogPaperStyle={{
            maxWidth: 1200,
            '& .MuiDialogContent-root': {
              padding: '0px !important'
            }
          }}
        >
          <MonthlyReportTab inputMonths={data?.month} inputYear={data?.year} />
        </CustomDialog>
      )}
    </>
  )
}

export default memo(CreditUsageEvent)
